import { I18n } from '@aws-amplify/core';

import { FIRST_VERSION_INDEX } from '@/views/Bera/constants';

export function getVersionLabel(index: number): string {
	if (index === FIRST_VERSION_INDEX) {
		const initial = I18n.get('Initial version');
		return initial;
	}

	const label = `${I18n.get('Revision')} ${index}`;
	return label;
}
